/* línkè · 预设（Presets）
   控制"克克怎么说"——叙事风格、详细度、温度、最大长度。
   v1: 单激活（active 是一个 id，不做多选叠加） */

const K_LIST = 'lingke.preset.list';
const K_ACTIVE = 'lingke.preset.active';

export const DEFAULT_TEMPERATURE = 0.7;
export const DEFAULT_MAX_TOKENS = 4096;

function uid() {
  if (typeof crypto !== 'undefined' && crypto.randomUUID) return crypto.randomUUID();
  return 'p-' + Date.now().toString(36) + '-' + Math.random().toString(36).slice(2, 8);
}

function readJSON(key, fallback) {
  try {
    const raw = localStorage.getItem(key);
    if (!raw) return fallback;
    return JSON.parse(raw);
  } catch {
    return fallback;
  }
}
function writeJSON(key, value) {
  try { localStorage.setItem(key, JSON.stringify(value)); } catch {}
}

export function loadPresets() {
  return readJSON(K_LIST, []);
}
export function savePresets(list) {
  writeJSON(K_LIST, list);
}
export function getActivePresetId() {
  try { return localStorage.getItem(K_ACTIVE); } catch { return null; }
}
export function setActivePresetId(id) {
  try {
    if (id) localStorage.setItem(K_ACTIVE, id);
    else localStorage.removeItem(K_ACTIVE);
  } catch {}
}
export function getActivePreset() {
  const id = getActivePresetId();
  if (!id) return null;
  return loadPresets().find((p) => p.id === id) || null;
}

export function createPreset(partial = {}) {
  return {
    id: uid(),
    name: partial.name || '未命名',
    system_addition: partial.system_addition || '',
    temperature:
      typeof partial.temperature === 'number' ? partial.temperature : DEFAULT_TEMPERATURE,
    max_tokens:
      typeof partial.max_tokens === 'number' ? partial.max_tokens : DEFAULT_MAX_TOKENS,
    enabled: partial.enabled !== false,
  };
}

export function upsertPreset(p) {
  const list = loadPresets();
  const idx = list.findIndex((x) => x.id === p.id);
  if (idx === -1) list.push(p);
  else list[idx] = p;
  savePresets(list);
  return p;
}

export function deletePreset(id) {
  const list = loadPresets().filter((p) => p.id !== id);
  savePresets(list);
  if (getActivePresetId() === id) {
    setActivePresetId(list[0]?.id || null);
  }
}

/* 首次启动 bootstrap：建一个"默认"预设并激活 */
export function ensurePresetsBootstrap() {
  const list = loadPresets();
  if (list.length > 0) {
    if (!getActivePresetId()) setActivePresetId(list[0].id);
    return list[0];
  }
  const p = createPreset({
    name: '默 认',
    system_addition: '',
    temperature: DEFAULT_TEMPERATURE,
    max_tokens: DEFAULT_MAX_TOKENS,
  });
  savePresets([p]);
  setActivePresetId(p.id);
  return p;
}
